import { render, staticRenderFns } from "./ProfileAction.vue?vue&type=template&id=18d76fae&scoped=true&"
import script from "./ProfileAction.vue?vue&type=script&lang=js&"
export * from "./ProfileAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d76fae",
  null
  
)

export default component.exports